import type { DropdownProps } from 'core/components/ui';
import { Dropdown } from 'core/components/ui';
import type { ForwardedRef, PropsWithChildren } from 'react';
import { useImperativeHandle } from 'react';
import type { NodeWithMenu, GetContextMenuItems } from './types';
import { useContextMenu } from './useContextMenu';

const trigger: DropdownProps['trigger'] = ['contextMenu'];

export type ContextMenuProps<TNode extends NodeWithMenu> = PropsWithChildren<{
  onClick: (key: string, node?: TNode) => void;
  defaultItems: GetContextMenuItems<TNode>;
  createMenuRef?: ForwardedRef<(n: TNode) => void>;
}>;

export function ContextMenu<TNode extends NodeWithMenu>({
  onClick,
  defaultItems,
  createMenuRef,
  ...props
}: ContextMenuProps<TNode>) {
  const { createMenu, menuProps, beforeOpenMenu } = useContextMenu<TNode>(defaultItems, onClick);

  useImperativeHandle(createMenuRef, () => createMenu);

  return (
    <Dropdown
      menu={menuProps}
      trigger={trigger}
      onOpenChange={(open: boolean) => open && beforeOpenMenu()}
      {...props}
    />
  );
}
